(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["b2b-price-summary"] && !Shopify.designMode) return;
  try {
    class B2bPriceSummary extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.section;
    this.currencyCode = this.dataset.currency || 'EUR';
    this.unitCents = 0;
    this.compareCents = 0;

    const locale = document.documentElement.lang || navigator.language || 'es';
    this.formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: this.currencyCode,
      minimumFractionDigits: 2
    });

    this._loadMoqMap();
    this._watchPriceDOM();
    this._bindQty();
    this._bindVariant();
    this._syncFromDOM();
    // Sincronizar visibilidad con el variant activo en la carga inicial
    setTimeout(() => {
      const vid = this._currentVariantId();
      if (vid !== null) this.hidden = !this._hasMoq(vid);
    }, 0);
  }

  _priceRoot() {
    return document.getElementById(`price-${this.sectionId}`);
  }

  _priceContainer() {
    return this._priceRoot()?.querySelector('.price.prod') || null;
  }

  _parseCents(text) {
    if (!text) return 0;
    const clean = text.trim().replace(/\s/g, '');
    const lastComma = clean.lastIndexOf(',');
    const lastDot   = clean.lastIndexOf('.');
    let normalized;
    if (lastComma > lastDot) {
      normalized = clean.replace(/\./g, '').replace(',', '.');
    } else {
      normalized = clean.replace(/,/g, '');
    }
    const num = parseFloat(normalized.replace(/[^0-9.]/g, ''));
    return isNaN(num) ? 0 : Math.round(num * 100);
  }

  _readPricesFromDOM() {
    const container = this._priceContainer();
    if (!container) return;

    const insEl = container.querySelector('ins .amount');
    const delEl = container.querySelector('del .amount');

    this.unitCents    = insEl ? this._parseCents(insEl.textContent) : 0;
    this.compareCents = delEl ? this._parseCents(delEl.textContent) : 0;

    if (!this.unitCents) {
      this.unitCents    = parseInt(container.dataset.b2bPrice, 10) || parseInt(this.dataset.unit, 10) || 0;
      this.compareCents = parseInt(container.dataset.b2bCompare, 10) || parseInt(this.dataset.compare, 10) || 0;
    }
  }

  _watchPriceDOM() {
    const root = this._priceRoot();
    if (!root) return;

    if (this._observer) this._observer.disconnect();

    let timer;
    this._observer = new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(() => this._syncFromDOM(), 50);
    });

    this._observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  _setSyncing(syncing) {
    this.classList.toggle('b2b-price-summary--syncing', syncing);
  }

  _syncFromDOM() {
    const prevUnit = this.unitCents;
    this._readPricesFromDOM();
    this._update();

    if (prevUnit !== this.unitCents) {
      this._setSyncing(true);
      clearTimeout(this._stableTimer);
      this._stableTimer = setTimeout(() => this._setSyncing(false), 200);
    } else if (!this.classList.contains('b2b-price-summary--syncing')) {
      this._setSyncing(false);
    }
  }

  _scheduleVariantSync() {
    clearTimeout(this._variantDoneTimer);
    this._setSyncing(true);

    [0, 50, 150, 300, 600, 1000, 1500, 2000].forEach((delay) => {
      setTimeout(() => this._syncFromDOM(), delay);
    });

    this._variantDoneTimer = setTimeout(() => this._setSyncing(false), 2100);
  }

  _findQtyInput() {
    return document.querySelector(
      `#quantity-${this.sectionId} input[type="number"], ` +
      `#quantity-${this.sectionId} input.qty`
    );
  }

  _bindQty() {
    const onQtyChange = () => this._update();
    document.addEventListener('input', (e) => {
      if (e.target.closest(`#quantity-${this.sectionId}`)) onQtyChange();
    });
    document.addEventListener('click', (e) => {
      if (e.target.closest(`#quantity-${this.sectionId} button`)) {
        requestAnimationFrame(onQtyChange);
      }
    });
  }

  _loadMoqMap() {
    const el = document.getElementById(`b2b-moq-map-${this.sectionId}`);
    try { this._moqMap = el ? JSON.parse(el.textContent) : {}; }
    catch (e) { this._moqMap = {}; }
  }

  _hasMoq(variantId) {
    if (this._moqMap && variantId != null) {
      return this._moqMap[String(variantId)] === true;
    }
    return false;
  }

  _currentVariantId() {
    const form = document.getElementById(`product-form-${this.sectionId}`);
    const input = form?.querySelector('input[name="id"]');
    return input ? parseInt(input.value, 10) : null;
  }

  _bindVariant() {
    document.addEventListener('product:variant-change', (event) => {
      if (event.detail?.sectionId && event.detail.sectionId !== this.sectionId) return;
      this._watchPriceDOM();
      this._scheduleVariantSync();
      const vid = event.detail?.variant?.id ?? this._currentVariantId();
      this.hidden = !this._hasMoq(vid);
    });
  }

  _qty() {
    return Math.max(1, parseInt(this._findQtyInput()?.value, 10) || 1);
  }

  _fmt(cents) {
    return this.formatter.format(cents / 100);
  }

  _update() {
    const qty          = this._qty();
    const totalCents   = this.unitCents * qty;
    const savingsCents = this.compareCents > this.unitCents
      ? (this.compareCents - this.unitCents) * qty
      : 0;

    this.querySelector('[data-b2b-unit]').textContent  = this._fmt(this.unitCents);
    this.querySelector('[data-b2b-qty]').textContent   = qty;
    this.querySelector('[data-b2b-total]').textContent = this._fmt(totalCents);

    const savingsRow = this.querySelector('[data-b2b-savings-row]');
    if (savingsRow) {
      if (savingsCents > 0) {
        this.querySelector('[data-b2b-savings]').textContent = this._fmt(savingsCents);
        savingsRow.hidden = false;
      } else {
        savingsRow.hidden = true;
      }
    }
  }
}

if (!customElements.get('b2b-price-summary')) {
  customElements.define('b2b-price-summary', B2bPriceSummary);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["b2b-registration-form"] && !Shopify.designMode) return;
  try {
    (function () {
  var formId = document.currentScript
    ? document.currentScript.closest('[id]')
    : null;

  function initB2BForm(formEl) {
    if (!formEl) return;

    var fid = formEl.id;
    var tsInput = document.getElementById(fid + '-ts');
    if (tsInput) tsInput.value = Date.now().toString();

    var countrySelect = document.getElementById(fid + '-country');
    var countryOtherField = document.getElementById(fid + '-countryOtherField');
    var countryOtherInput = document.getElementById(fid + '-countryOther');

    if (countrySelect && countryOtherField) {
      function toggleCountryOther() {
        var isOther = countrySelect.value === 'OTHER';
        countryOtherField.hidden = !isOther;
        countryOtherField.classList.toggle('b2b-form__field--hidden', !isOther);
        if (countryOtherInput) {
          countryOtherInput.required = isOther;
          countryOtherInput.setAttribute('aria-required', isOther ? 'true' : 'false');
          if (!isOther) {
            countryOtherInput.value = '';
            setFieldError(fid, 'countryOther', '');
          }
        }
      }

      countrySelect.addEventListener('change', toggleCountryOther);
      toggleCountryOther();
    }

    var inputs = formEl.querySelectorAll('input, select, textarea');
    inputs.forEach(function (input) {
      if (input.name === '_hp' || input.name === '_ts') return;
      input.addEventListener('blur', function () {
        validateField(fid, input);
      });
      input.addEventListener('input', function () {
        if (input.getAttribute('aria-invalid') === 'true') {
          validateField(fid, input);
        }
      });
    });

    formEl.addEventListener('submit', function (e) {
      e.preventDefault();
      handleSubmit(formEl, fid);
    });
  }

  function isFieldVisible(input) {
    var field = input.closest('.b2b-form__field');
    if (!field) return true;
    return !field.hidden && !field.classList.contains('b2b-form__field--hidden');
  }

  function validateField(fid, input) {
    var name = input.name;
    var value = input.value.trim();
    var error = '';

    if (name === '_hp' || name === '_ts') return true;
    if (!isFieldVisible(input)) return true;

    if (input.required && value === '') {
      error = 'Este campo es obligatorio.';
    } else if (name === 'email' && value) {
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        error = 'Introduce un email válido.';
      }
    } else if (name === 'website' && value) {
      if (!/^https?:\/\/.+\..+/.test(value)) {
        error = 'El sitio web debe ser una URL válida (https://...).';
      }
    } else if (name === 'businessDescription' && value && value.length < 20) {
      error = 'Describe tu empresa en al menos 20 caracteres.';
    } else if (name === 'country' && value === '') {
      error = 'Selecciona un país.';
    } else if (name === 'countryOther' && input.required && value === '') {
      error = 'Indica el país.';
    }

    setFieldError(fid, name, error);
    return error === '';
  }

  function setFieldError(fid, name, message) {
    var errorEl = document.getElementById(fid + '-' + name + '-error');
    var inputEl = document.querySelector(
      '#' + fid + ' [name="' + name + '"]'
    );
    if (errorEl) errorEl.textContent = message;
    if (inputEl) {
      if (message) {
        inputEl.setAttribute('aria-invalid', 'true');
      } else {
        inputEl.removeAttribute('aria-invalid');
      }
    }
  }

  function validateAll(formEl, fid) {
    var fields = formEl.querySelectorAll('input, select, textarea');
    var valid = true;
    var firstInvalid = null;
    fields.forEach(function (f) {
      if (f.name === '_hp' || f.name === '_ts') return;
      var fieldValid = validateField(fid, f);
      if (!fieldValid && !firstInvalid) firstInvalid = f;
      if (!fieldValid) valid = false;
    });
    if (firstInvalid) firstInvalid.focus();
    return valid;
  }

  function setLoading(fid, loading) {
    var btn = document.getElementById(fid + '-submit');
    var textEl = btn ? btn.querySelector('.b2b-form__submit-text') : null;
    var loadingEl = btn ? btn.querySelector('.b2b-form__submit-loading') : null;
    if (!btn) return;
    btn.disabled = loading;
    if (textEl) textEl.hidden = loading;
    if (loadingEl) loadingEl.hidden = !loading;
  }

  function showSuccess(fid) {
    var successEl = document.getElementById(fid + '-success');
    if (successEl) successEl.hidden = false;
    var formEl = document.getElementById(fid);
    if (formEl) {
      var fields = formEl.querySelectorAll('.b2b-form__grid, .b2b-form__field, .b2b-form__actions');
      fields.forEach(function (f) { f.hidden = true; });
    }
  }

  function showError(fid, message) {
    var errorBanner = document.getElementById(fid + '-error');
    var errorMsg = document.getElementById(fid + '-error-message');
    if (errorBanner) errorBanner.hidden = false;
    if (errorMsg) errorMsg.textContent = message || 'No hemos podido procesar tu solicitud. Inténtalo de nuevo más tarde.';
  }

  function hideError(fid) {
    var errorBanner = document.getElementById(fid + '-error');
    if (errorBanner) errorBanner.hidden = true;
  }

  function handleSubmit(formEl, fid) {
    hideError(fid);

    if (!validateAll(formEl, fid)) return;

    setLoading(fid, true);

    var proxyUrl = formEl.dataset.proxyUrl || '/apps/b2b-register';
    var fd = new FormData(formEl);
    var body = {};
    fd.forEach(function (value, key) {
      body[key] = value;
    });

    fetch(proxyUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, status: res.status, data: data };
        });
      })
      .then(function (result) {
        setLoading(fid, false);
        if (result.data.ok) {
          showSuccess(fid);
        } else if (result.data.fieldErrors) {
          Object.keys(result.data.fieldErrors).forEach(function (key) {
            setFieldError(fid, key, result.data.fieldErrors[key]);
          });
          var firstErrField = formEl.querySelector('[aria-invalid="true"]');
          if (firstErrField) firstErrField.focus();
        } else {
          showError(fid, result.data.message);
        }
      })
      .catch(function () {
        setLoading(fid, false);
        showError(fid, 'No hemos podido procesar tu solicitud. Inténtalo de nuevo más tarde.');
      });
  }

  document.querySelectorAll('.b2b-form').forEach(function (formEl) {
    initB2BForm(formEl);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
